import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { kycAuth } from "../Redux/Action/kyc/kycAuthAction";
import {
  Badge,
  Box,
  Button,
  HStack,
  IconButton,
  Image,
  Strong,
  Table,
  VStack,
} from "@chakra-ui/react";
import { completeKYC } from "../Redux/Action/kyc/completeKYCAction";
import { S3_BUCKET_BASE_URL, REG_PARAMS, COMPANY_NAME } from "../Utils/Constants";
import { IoOpenOutline } from "react-icons/io5";
import { IoMdCheckmark } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { UserListSkeleton } from "../Components/custom/Skeletons/UserListSkeleton";
import { CustomPagination } from "../Components/custom/CustomPagination";
import { getLocalStorageItem } from "../Utils/Helper";
import { setDynamicTitle } from "../Utils/dynamicTitleManager";

export const ManageKYC = () => {
  // Use dynamic title management
  useEffect(() => {
    setDynamicTitle("Manage KYC");
  }, []);

  const [pendingKYCUsers, setPendingKYCUsers] = useState([]);
  const [isDataLoading, setisDataLoading] = useState(true);
  const [totalPagesCount, setTotalPagesCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowCount, setRowCount] = useState(10);
  const whitelabelId= getLocalStorageItem("whitelabelData")
  const dispatch = useDispatch();

  useEffect(() => {
    setisDataLoading(true);
    const payload = {
      currentPage,
      rowCount,
    };
    if(whitelabelId!==null)
    {
      payload.whitelabelId=whitelabelId._id
      
    }
    dispatch(
      completeKYC({
        payload,
        callback: (data) => {
        
          if (data.meta.code === 200) {
            setPendingKYCUsers(data?.data);
            setTotalPagesCount(data?.meta?.totalPages);
            setisDataLoading(false);
          }
          else{
              setisDataLoading(false);
          }

        },
      })

    );
    
  }, [currentPage]);

  const handleSubmit = (item, type) => {
 
  
    const keyToDelete = item?._id
    let payload = {
      email: item?.email,
      type,
      uid: item?.uid,
      companyName: COMPANY_NAME,
    };
      if(whitelabelId!==null)
      {
        payload.whitelabelId=whitelabelId._id
        payload.paramtype=REG_PARAMS
      }
    dispatch(
      kycAuth({
        payload,
        callback: (data) => {
          if (data?.meta?.code === 200) {
            setPendingKYCUsers(prevUsers =>
              prevUsers.filter(user => !keyToDelete.includes(user._id))
            );
          }
        }
      })
    );
  };

  return (
    <VStack>
      {isDataLoading ? (
        <UserListSkeleton />
      ) : (
        <Table.ScrollArea
          borderWidth="1px"
          rounded="md"
          height="70vh"
          width="100%"
        >
          <Table.Root size="sm" interactive variant="outline" stickyHeader>
            <Table.Header>
              <Table.Row>
                <Table.ColumnHeader width="20%" textAlign="center">
                  Full Name
                </Table.ColumnHeader>
                <Table.ColumnHeader width="15%" textAlign="center">
                  Proof of Identity(POI)(Front)
                </Table.ColumnHeader>
                <Table.ColumnHeader width="15%" textAlign="center">
                  Proof of Identity(POI)(Back)
                </Table.ColumnHeader>
                <Table.ColumnHeader width="15%" textAlign="center">
                  Proof of Address(POA)
                </Table.ColumnHeader>
                <Table.ColumnHeader width="15%" textAlign="center">
                  User Agreement
                </Table.ColumnHeader>
                <Table.ColumnHeader width="20%" textAlign="center">
                  Actions
                </Table.ColumnHeader>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {pendingKYCUsers?.length > 0 ? (
                pendingKYCUsers.map((item) => (
                  <Table.Row key={item._id}>
                    <Table.Cell>
                      <VStack width="100%">
                        <HStack width="100%" justifyContent="center">
                          <Strong>
                            {item.fname} {item.lname}
                          </Strong>
                        </HStack>
                        <HStack width="100%" justifyContent="center">
                          <Badge colorPalette="blue" variant="surface" size="sm">
                            {item.email}
                          </Badge>
                        </HStack>
                      </VStack>
                    </Table.Cell>
                    {[
                      { key: "front", label: "Front" },
                      { key: "back", label: "Back" },
                      { key: "other", label: "Address" }
                    ].map(({ key, label }) => {
                      const file = item.kyc_images?.[key];
                      const isPdf = file?.toLowerCase().endsWith(".pdf");
                      // Check if file is already a full URL (starts with http/https)
                      const fileUrl = file
                        ? (file.startsWith('http') ? file : `${S3_BUCKET_BASE_URL}/${file}`)
                        : null;

                      return (
                        <Table.Cell key={key}>
                          <HStack width="100%" justifyContent="center">
                            {file ? (
                              isPdf ? (
                                <Button
                                  variant="surface"
                                  colorPalette="green"
                                  size="sm"
                                  onClick={() => window.open(fileUrl, "_blank")}
                                >
                                  <IoOpenOutline />
                                  Click to Preview {label} PDF
                                </Button>
                              ) : (
                                <Image
                                  src={fileUrl}
                                  alt={`KYC ${key}`}
                                  boxSize="50%"
                                  objectFit="cover"
                                />
                              )
                            ) : (
                              "-"
                            )}
                          </HStack>
                        </Table.Cell>
                      );
                    })}
                    {/* User Agreement Column */}
                    <Table.Cell>
                      <HStack width="100%" justifyContent="center">
                        {item.kyc_images?.agreement ? (
                          <Button
                            variant="surface"
                            colorPalette="blue"
                            size="sm"
                            onClick={() => window.open(
                              item.kyc_images.agreement.startsWith('http')
                                ? item.kyc_images.agreement
                                : `${S3_BUCKET_BASE_URL}/${item.kyc_images.agreement}`,
                              "_blank"
                            )}
                          >
                            <IoOpenOutline />
                            View Agreement PDF
                          </Button>
                        ) : (
                          "-"
                        )}
                      </HStack>
                    </Table.Cell>
                    <Table.Cell textAlign="end">
                      <HStack justifyContent="center" width="100%">
                        <IconButton
                          aria-label="Call support"
                          rounded="full"
                          variant="surface"
                          colorPalette="green"
                          onClick={() => handleSubmit(item, "accept")}
                        >
                          <IoMdCheckmark />
                        </IconButton>
                        <IconButton
                          aria-label="Call support"
                          rounded="full"
                          variant="surface"
                          colorPalette="red"
                          onClick={() => handleSubmit(item, "reject")}
                        >
                          <IoMdClose />
                        </IconButton>
                      </HStack>
                    </Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan={6} textAlign="center" py={6}>
                    No KYC data available
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table.Root>
        </Table.ScrollArea>
      )}
      <CustomPagination
        totalCount={totalPagesCount}
        current={currentPage}
        setCurrent={setCurrentPage}
        isLoading={isDataLoading}
      />
    </VStack>
  );
};
